import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { organizationService } from "../lib/api/organization";
import { routes } from "../routes/routes-names";
import Swal from "sweetalert2";
import { eventService } from "../lib/api/event";
import MainHeader from "../pages/MainHeader";
import OrgPrintCertificateComponent from "../pages/OrgPrintCertificateComponent"

const PaymentSuccess = () => {

    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(true);
    const [transactionMsg, setTransactionMsg] = useState('');
    const [paymentDetails, setPaymentDetails] = useState<{
        orderId?: string;
        orderAmount?: string;
        paymentDateTime?: string;
        paymentMethod?: string;
        paymentTransactionId?: string;
    } | null>(null);
    const [orgRegNumber, setOrgRegNumber] = useState<any>();
    const [orgName, setOrgName] = useState<any>();
    const [orgDate, setOrgDate] = useState<any>();
    const [orgExpDate, setOrgExpDate] = useState<any>();

    useEffect(() => {
        (async () => {

            try {
                setIsLoader(true);
                const respOrderKeyId = secureLocalStorage.getItem("respOrderKeyId");
                const respOrganizationId = secureLocalStorage.getItem("respOrganizationId");

                const regType = secureLocalStorage.getItem("regType");
                // Avoid logging sensitive payment details

                if (regType === 'organization'&& respOrganizationId!==null && respOrderKeyId!==null ) {
                    const formData = new FormData();
                    formData.append("inputOrderId", JSON.stringify(respOrderKeyId));
                    formData.append("intOrganizationId", JSON.stringify(respOrganizationId));
                    const { success, data, message } = await organizationService.updateOrganizationPaymentDetails(formData);
                    if (success) {
                         secureLocalStorage.removeItem("respOrderKeyId");
                         secureLocalStorage.removeItem("respOrganizationId");
                        setIsLoader(false);
                        setPaymentDetails({
                            orderId: data.orderId,
                            orderAmount: data.orderAmount,
                            paymentDateTime: data.paymentDateTime,
                            paymentMethod: data.paymentMethod,
                            paymentTransactionId: data.paymentTransactionId,
                        });
                        setOrgName(data.orgName);
                        setOrgDate(data.orgApprovedDate);
                        setOrgExpDate(data.orgExpDate);
                        setOrgRegNumber(data.tgmcOrgNumber);
                        Swal.fire({
                            title: "Success",
                            text: "Organization registration successfully completed",
                            icon: "success",
                            confirmButtonText: "OK",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                // navigate(routes.userpanal);
                            }
                        });
                    } else {
                        setIsLoader(false);
                        setTransactionMsg(message);
                        setPaymentDetails(null);
                    }
                }


                if (regType === 'event') {
                    const eventId = secureLocalStorage.getItem("eventId");
                    const formData = new FormData();
                    formData.append("inputOrderId", JSON.stringify(respOrderKeyId));
                    formData.append("intEventId", JSON.stringify(eventId));
                    const { success, data, message } = await eventService.updateEventPaymentDetails(formData);
                    if (success) {
                        setIsLoader(false);
                        secureLocalStorage.removeItem("respOrderKeyId");
                         secureLocalStorage.removeItem("eventId");
                        setPaymentDetails({
                            orderId: data.orderId,
                            orderAmount: data.orderAmount,
                            paymentDateTime: data.paymentDateTime,
                            paymentMethod: data.paymentMethod,
                            paymentTransactionId: data.paymentTransactionId,
                        });
                        Swal.fire({
                            title: "Success",
                            text: "Event registration successfully completed",
                            icon: "success",
                            confirmButtonText: "OK",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                // navigate(routes.userpanal);
                            }
                        });
                    } else {
                        setIsLoader(false);
                        setTransactionMsg(message);
                        setPaymentDetails(null);
                    }
                }

            } catch (error) {
                setIsLoader(false);
                // Avoid logging sensitive payment errors
            }
            setIsLoader(false);
        })();
    }, []);

    return (
        <>
            <MainHeader />
            <section className='gray-banner mt-5'>
                <div className="card-body">
                    <div className="row mb-3">
                        <div className="col"></div>
                        <div className="col"></div>
                    </div>
                    {isLoader ? (
                        <div className="d-flex justify-content-center">
                            <div className="spinner-border text-success mt-5" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div className='text-danger fs-11'>
                                please do not press back button or refresh
                            </div>

                        </div>
                    ) :
                        <>
                            {(transactionMsg.includes("Failed") ||transactionMsg.includes("Something") || transactionMsg === "") ?
                                <div className="card-body">

                                    <div className="w-100 text-center">
                                        <i className="bi-x-circle fs-42 text-danger"></i>
                                        <h1 className='fs-22 fw-700'>Payment Error</h1>
                                    </div>
                                </div>
                                :
                                <div className="col-11">
                                    <div className="w-100 text-center">
                                        <i className="bi-check-circle fs-42 text-success"></i>
                                        <h1 className='fs-22 fw-700'>Payment Success</h1>
                                    </div>  
                                       <div className="px-3 text-center">
                                        <p className="mb-3" id="printPageButton">Your Organization successfully registered with  <br /> Telangana State Medical Council</p>
                                       <hr />

                                    </div>
                                </div>
                            }
                        </>

                    }
                    <div className="col-11 text-center" style={{ marginLeft: "400px" }} id="msgId">
                        {transactionMsg && <div className="fw-semibold">{transactionMsg}</div>}
                        {paymentDetails && (
                            <table className="table table-borderless mt-2 mb-0">
                                <tbody>
                                    <tr><td><b>Payment Details</b></td></tr>
                                    <tr><td>Order Id :: <b>{paymentDetails.orderId}</b></td></tr>
                                    <tr><td>Amount Paid :: <b>{paymentDetails.orderAmount}</b></td></tr>
                                    <tr><td>Payment Date and Time (DD-MM-YYYY) :: <b>{paymentDetails.paymentDateTime}</b></td></tr>
                                    <tr><td>Payment Method :: <b>{paymentDetails.paymentMethod}</b></td></tr>
                                    <tr><td>Payment TransactionId :: <b>{paymentDetails.paymentTransactionId}</b></td></tr>
                                </tbody>
                            </table>
                        )}
                    </div>
                    {isLoader===false && secureLocalStorage.getItem("regType")==="organization" &&
                         <>
                        {secureLocalStorage.getItem("regType")==="organization"&&<OrgPrintCertificateComponent
                            orgName={orgName}
                            orgRegNumber={orgRegNumber}
                            orgDate={orgDate}
                            orgExpDate={orgExpDate}
                        />}
                        <hr />  
                      
                    </>
                    }
                      <button type="button"  onClick={() => { navigate(routes.main); }} style={{ marginLeft: "600px" }}  className="cme-button fw-semibold">Back to Login</button>

                  
                </div>


            </section>
        </>
    )
};

export default PaymentSuccess;
